export interface IDataPoints {
    id: number;
    name: string;
}
export interface IAdditionalFields {
    blankFieldId: number;
    displayName: string;
    dataPoints: IDataPoints[];
    selected: string[];
    delimiter: string;
}

export interface IDataPointsAddFields {
    dataPoints: IDataPoints[];
    additionalFields: IAdditionalFields[];
}

export function newAdditionalFields(): IDataPointsAddFields {
    const result: IDataPointsAddFields = {
        dataPoints: [],
        additionalFields: [],
    };
    return result;
}
